"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const services_1 = tslib_1.__importDefault(require("../../../../services"));
const getById_1 = tslib_1.__importDefault(require("../getById"));
const updateModel = {
    data: {
        type: 'booking',
        attributes: {
            customer_id: null,
        },
    },
};
const removeBookingCustomer = toolkitRaw.createAsyncThunk('bookings/fetch_remove_booking_customer', async (data, { rejectWithValue, dispatch }) => {
    try {
        await services_1.default.put(`/api/saas/me/bookings/${data.bookingInternalId}`, updateModel);
        await dispatch((0, getById_1.default)({
            id: String(data.bookingInternalId),
        }));
        return null;
    }
    catch (eventError) {
        return rejectWithValue(eventError);
    }
});
exports.default = removeBookingCustomer;
//# sourceMappingURL=index.js.map